import React from 'react';

export { welcomeScreenFillStyle, getBackgroundGradient } from '../utils/welcomeScreenFillStyle';

export function WelcomeScreenPhotoBackground({ imageUrl, zIndex = 0 }) {
  if (!imageUrl) return null;
  return (
    <img
      src={imageUrl}
      alt=""
      decoding="async"
      draggable={false}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center center',
        zIndex,
        pointerEvents: 'none',
        userSelect: 'none',
        WebkitUserDrag: 'none',
      }}
    />
  );
}

/** Только оформление приветствия (без новостной карусели). */
export default function WelcomeScreenHero({ appTitleSettings }) {
  if (!appTitleSettings) return null;

  return (
    <>
      <style>{`
             @keyframes welcomeNeonGlow {
               0% { text-shadow: 0 0 ${Number(appTitleSettings.welcomeScreenGlowIntensity) || 12}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 ${(Number(appTitleSettings.welcomeScreenGlowSpread) || 32) * 0.5}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 2px #fff, 0 0 ${(Number(appTitleSettings.welcomeScreenGlowSpread) || 32) * 0.75}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}88; }
               50% { text-shadow: 0 0 ${(Number(appTitleSettings.welcomeScreenGlowIntensity) || 12) * 2}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 ${Number(appTitleSettings.welcomeScreenGlowSpread) || 32}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 4px #fff, 0 0 ${Number(appTitleSettings.welcomeScreenGlowSpread) || 32}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}cc; }
               100% { text-shadow: 0 0 ${Number(appTitleSettings.welcomeScreenGlowIntensity) || 12}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 ${(Number(appTitleSettings.welcomeScreenGlowSpread) || 32) * 0.5}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, 0 0 2px #fff, 0 0 ${(Number(appTitleSettings.welcomeScreenGlowSpread) || 32) * 0.75}px ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}88; }
             }
             .welcome-neon-glow { animation: welcomeNeonGlow 1.6s infinite alternate; }
             .welcome-gradient-animation {
               background: linear-gradient(-45deg, ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, ${appTitleSettings.welcomeScreenColor || '#43e97b'}, ${appTitleSettings.welcomeScreenGlowColor || '#43e97b'}, ${appTitleSettings.welcomeScreenColor || '#43e97b'}) !important;
               background-size: 400% 400% !important;
               animation: welcomeGradientAnim 3s ease infinite !important;
               -webkit-background-clip: text !important;
               -webkit-text-fill-color: transparent !important;
               background-clip: text !important;
               color: transparent !important;
             }
             @keyframes welcomeGradientAnim {
               0% { background-position: 0% 50%; }
               50% { background-position: 100% 50%; }
               100% { background-position: 0% 50%; }
             }
             @keyframes welcomeSnowFall {
               0% { transform: translateY(0) translateX(0); opacity: 0.85; }
               80% { opacity: 0.85; }
               100% { transform: translateY(640px) translateX(var(--snow-x, 0px)); opacity: 0.2; }
             }
           `}</style>

      {(() => {
        const bgVideo = (appTitleSettings.welcomeScreenImages || []).find(
          (item) => item?.mediaType === 'video' && item?.isBackground && item?.image
        );
        if (!bgVideo) return null;
        return (
          <video
            src={bgVideo.image}
            muted={bgVideo.muted !== false}
            loop={bgVideo.loop !== false}
            autoPlay={bgVideo.autoplay !== false}
            controls={!!bgVideo.controls}
            playsInline
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: bgVideo.fitMode || 'cover',
              transform: `translate(${bgVideo.positionX || 0}px, ${bgVideo.positionY || 0}px) scale(${(bgVideo.scaleX || 100) / 100}, ${(bgVideo.scaleY || 100) / 100})`,
              transformOrigin: 'center',
              zIndex: 5,
            }}
          />
        );
      })()}
      {appTitleSettings.welcomeScreenSnowEnabled && (
        <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 15 }}>
          {Array.from({ length: 14 }).map((_, i) => (
            <span
              key={i}
              style={{
                position: 'absolute',
                top: '-32px',
                left: `${(i / 14) * 100}%`,
                color: '#fff',
                opacity: 0.85,
                userSelect: 'none',
                pointerEvents: 'none',
                animation: `welcomeSnowFall ${4 + (i % 3)}s linear infinite`,
                animationDelay: `${i * 0.45}s`,
                fontSize: `${12 + (i % 4) * 2}px`,
                textShadow: '0 0 8px #fff, 0 0 12px #6dd5ed',
                ['--snow-x']: `${-30 + (i % 7) * 12}px`,
              }}
            >
              ❄
            </span>
          ))}
        </div>
      )}

      {(appTitleSettings.welcomeScreenImages || []).map((img, index) =>
        img.image && !img.isBackground ? (
          img.mediaType === 'video' ? (
            <video
              key={index}
              src={img.image}
              muted={img.muted !== false}
              loop={img.loop !== false}
              autoPlay={img.autoplay !== false}
              controls={!!img.controls}
              playsInline
              style={{
                position: 'absolute',
                left: `calc(50% + ${img.positionX || 0}px)`,
                top: `${img.positionY || 0}px`,
                transform: 'translateX(-50%)',
                width: `${img.width || 100}px`,
                height: `${img.height || 100}px`,
                objectFit: 'contain',
                zIndex: 10,
                userSelect: 'none',
              }}
            />
          ) : (
            <img
              key={index}
              src={img.image}
              alt={`welcome-${index}`}
              draggable={false}
              style={{
                position: 'absolute',
                ...(img.fillWelcomeArea
                  ? {
                      inset: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: img.fitMode || 'cover',
                      transform: `translate(${img.positionX || 0}px, ${img.positionY || 0}px) scale(${(img.imageDisplayScale ?? 100) / 100})`,
                      transformOrigin: 'center center',
                      zIndex: 8,
                    }
                  : {
                      left: `calc(50% + ${img.positionX || 0}px)`,
                      top: `${img.positionY || 0}px`,
                      transform: `translateX(-50%) scale(${(img.imageDisplayScale ?? 100) / 100})`,
                      width: `${img.width || 100}px`,
                      height: `${img.height || 100}px`,
                      objectFit: 'contain',
                      zIndex: 10,
                    }),
                userSelect: 'none',
              }}
            />
          )
        ) : null
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 7,
          fontSize: `${parseFloat((appTitleSettings.welcomeScreenSubtitleFontSize || '1.1em').replace('em', '')) * (appTitleSettings.welcomeScreenSubtitleScale || 100) / 100}em`,
          color: appTitleSettings.welcomeScreenSubtitleColor || '#fff',
          fontWeight: 700,
          letterSpacing: 1.5,
          textShadow: '0 1px 8px #232931',
          position: 'absolute',
          top: `calc(50% + ${appTitleSettings.welcomeScreenSubtitlePositionY || 0}px)`,
          left: `calc(50% + ${appTitleSettings.welcomeScreenSubtitlePositionX || 0}px)`,
          transform: 'translate(-50%, -50%)',
          zIndex: 20,
        }}
      >
        <span>💬</span>
        {appTitleSettings.welcomeScreenSubtitleText || 'Мульти - мессенджер'}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          top: `calc(50% + ${appTitleSettings.welcomeScreenTextPositionY || 0}px)`,
          left: `calc(50% + ${appTitleSettings.welcomeScreenTextPositionX || 0}px)`,
          transform: `translate(-50%, -50%) scale(${(appTitleSettings.welcomeScreenTextScale || 100) / 100})`,
          zIndex: 20,
        }}
      >
        {(() => {
          const wsSettings = appTitleSettings;
          const effectType = wsSettings.welcomeScreenEffectType || 'neon';
          const style = {
            fontFamily: wsSettings.welcomeScreenCustomFontName || wsSettings.welcomeScreenFontFamily || 'Arial, sans-serif',
            fontSize: wsSettings.welcomeScreenFontSize || '2em',
            fontWeight: 900,
            marginBottom: 2,
            transition: 'all 0.3s',
            lineHeight: 1.1,
            letterSpacing: 1.2,
            display: 'inline-block',
          };
          let className = '';
          if (wsSettings.welcomeScreenUseGradient === true && effectType !== 'gradient-animation') {
            style.background = `linear-gradient(135deg, ${wsSettings.welcomeScreenGradientStart || '#43e97b'} 0%, ${wsSettings.welcomeScreenGradientEnd || '#2193b0'} 100%)`;
            style.WebkitBackgroundClip = 'text';
            style.WebkitTextFillColor = 'transparent';
            style.backgroundClip = 'text';
            style.color = 'transparent';
          } else if (effectType === 'gradient-animation' && wsSettings.welcomeScreenGlowEnabled) {
            className = 'welcome-gradient-animation';
            style.color = 'transparent';
          } else {
            style.color = wsSettings.welcomeScreenColor || '#43e97b';
          }
          const glowColor = wsSettings.welcomeScreenGlowColor ? String(wsSettings.welcomeScreenGlowColor).trim() : '#43e97b';
          const intensity = Number(wsSettings.welcomeScreenGlowIntensity) || 12;
          const spread = Number(wsSettings.welcomeScreenGlowSpread) || 32;
          if (wsSettings.welcomeScreenGlowEnabled === true) {
            switch (effectType) {
              case 'shadow':
                style.textShadow = `3px 3px 6px rgba(0,0,0,0.5), 0 0 ${intensity}px ${glowColor}, 0 0 ${spread}px ${glowColor}`;
                break;
              case 'outline':
                style.textShadow = `-1px -1px 0 ${glowColor}, 1px -1px 0 ${glowColor}, -1px 1px 0 ${glowColor}, 1px 1px 0 ${glowColor}, 0 0 ${intensity}px ${glowColor}, 0 0 ${spread}px ${glowColor}`;
                break;
              case 'sparkle':
                style.textShadow = `0 0 ${intensity}px ${glowColor}, 0 0 ${spread}px ${glowColor}, 0 0 ${spread * 1.5}px ${glowColor}, 2px 2px 4px rgba(0,0,0,0.3), -2px -2px 4px ${glowColor}88`;
                break;
              case 'gradient-animation':
                break;
              case 'new-year':
                style.textShadow = `0 0 ${intensity}px ${glowColor}, 0 0 ${spread}px ${glowColor}`;
                break;
              case 'neon':
              default:
                className = 'welcome-neon-glow';
                break;
            }
          } else {
            style.textShadow = 'none';
          }
          return (
            <span className={className} style={style}>
              {wsSettings.welcomeScreenText || 'Issa Plus'}
            </span>
          );
        })()}
      </div>

      {appTitleSettings.welcomeScreenDescriptionText && (
        <div
          style={{
            position: 'absolute',
            top: `calc(50% + ${appTitleSettings.welcomeScreenDescriptionPositionY || 200}px)`,
            left: `calc(50% + ${appTitleSettings.welcomeScreenDescriptionPositionX || 0}px)`,
            transform: `translate(-50%, -50%) scale(${(appTitleSettings.welcomeScreenDescriptionScale || 100) / 100})`,
            zIndex: 20,
            maxWidth: `${appTitleSettings.welcomeScreenDescriptionMaxWidth || 600}px`,
            fontFamily: appTitleSettings.welcomeScreenDescriptionFontFamily || 'Arial, sans-serif',
            fontSize: appTitleSettings.welcomeScreenDescriptionFontSize || '1em',
            color: appTitleSettings.welcomeScreenDescriptionColor || '#fff',
            textAlign: 'center',
            lineHeight: 1.5,
            wordWrap: 'break-word',
          }}
          dangerouslySetInnerHTML={{ __html: appTitleSettings.welcomeScreenDescriptionText }}
        />
      )}
    </>
  );
}
